import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aig-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
